var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleTicketShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1375.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Ticket-show",
    transform: "translate(2352.000000, 1375.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,17 L25,17 L25,16 L15,16 L15,17 Z M15,20 L25,20 L25,19 L15,19 L15,20 Z M15,14 L21,14 L21,12 L15,12 L15,14 Z M8,13 L10,13 L10,11 L8,11 L8,13 Z M8,17 L10,17 L10,15 L8,15 L8,17 Z M8,21 L10,21 L10,19 L8,19 L8,21 Z M32,12 L32,10 C32,8.343 30.657,7 29,7 L10,7 L10,9 L8,9 L8,7 L3,7 C1.343,7 0,8.343 0,10 L0,12 C1.104,12 2,12.896 2,14 L2,18 C2,19.105 1.104,20 0,20 L0,21 C0,22.657 1.343,25 3,25 L8,25 L8,23 L10,23 L10,25 L29,25 C30.657,25 32,23.657 32,22 L32,20 C30.896,20 30,19.105 30,18 L30,14 C30,12.896 30.896,12 32,12 L32,12 Z",
    id: 48
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleTicketShow);
export default __webpack_public_path__ + "static/media/life-and-people-ticket-show.9aa14d07.svg";
export { ForwardRef as ReactComponent };